/* Cara Dura · new LP behaviour: carousels, scroll-to-buy-box buttons, sticky add to cart. */
(function () {
  function buyForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (!forms[i].closest('.cdl-sticky')) return forms[i];
    }
    return null;
  }

  function buyTarget() {
    return document.querySelector('kaching-bundle, kaching-bundles-block, [class*="kaching-bundles"]') || buyForm();
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-cdl-track]');
    if (!track || track.getAttribute('data-cdl-ready')) return;
    track.setAttribute('data-cdl-ready', '1');
    var dots = root.querySelectorAll('[data-cdl-dots] span');
    function step() {
      var first = track.children[0];
      if (!first) return 300;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 12;
      return first.getBoundingClientRect().width + gap;
    }
    var prev = root.querySelector('[data-cdl-prev]');
    var next = root.querySelector('[data-cdl-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (dots.length) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / step());
        for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-on', j === i);
      }, { passive: true });
    }
  }

  function initSticky() {
    var bar = document.querySelector('[data-cdl-sticky]');
    if (!bar || bar.getAttribute('data-cdl-ready')) return;
    bar.setAttribute('data-cdl-ready', '1');
    var form = buyForm();
    if (!form || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(form);
  }

  function init() {
    var roots = document.querySelectorAll('[data-cdl-carousel]');
    for (var i = 0; i < roots.length; i++) initCarousel(roots[i]);
    initSticky();
  }

  document.addEventListener('click', function (e) {
    var scroller = e.target.closest('[data-cdl-scroll]');
    if (scroller) {
      var t = buyTarget();
      if (t) {
        e.preventDefault();
        window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
      }
      return;
    }
    var adder = e.target.closest('[data-cdl-add]');
    if (adder) {
      var form = buyForm();
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"], button[name="add"]');
      if (btn) btn.click();
      else if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
